module.exports = __webpack_public_path__ + "img/bank1.07e937b0.png";